import { IConfig } from '../interface/IConfig';

export default class CommonDataStore {

    private static _instance: CommonDataStore;

    private configData!: IConfig;
    private _nowYear: string = '0000';
    private _nowServer: string = '';
    private _nowPage: number = 1;
    private _isLast: boolean = false;

    public static get instance() {
        return this._instance || (this._instance = new this())
    }

    public get config(): IConfig{
        return this.configData;
    }
    public set config(_config: IConfig) {
        _config.country = _config.country? _config.country: 'kr';
        this.configData = _config;
    }

    public get nowYear(): string{
        return this._nowYear;
    }
    public set nowYear(_year: string) {
        this._nowYear = _year;
    }

    public get nowServer(): string{
        return this._nowServer;
    }
    public set nowServer(_server: string) {
        this._nowServer = _server;
    }

    public get nowPage(): number{
        return this._nowPage;
    }
    public set nowPage(_page: number) {
        this._nowPage = _page;
    }
    public addNowPage(){
        ++this._nowPage;
    }

    public get isLast(): boolean{
        return this._isLast;
    }
    public set isLast(_last: boolean) {
        this._isLast = _last;
    }

    public reSetAllData(_year: string, _server: string){
        this._nowYear = _year;
        this._nowServer = _server;
        this._isLast = false;
        this._nowPage = 1;
    }
 
} // end of class